import React from "react";

/* Real LinkedIn recommendations for Erin Amar */
const quotes = [
  {
    quote:
      "When it comes to top-tier marketing and communications, Erin is truly the best in the business. She has an uncanny ability to find areas of opportunity others overlook, while simultaneously bringing quality, strategic solutions to every problem. A skilled marketing professional, and an even better colleague.",
    author: "Natasha Fee",
    role: "Former Public Relations Officer at Boston Public Library",
    date: "October 2023",
    accent: "var(--bpm-orange)",
  },
  {
    quote:
      "When the BPL suddenly had to pivot and find new ways of maintaining its mission and serving patrons while closed under COVID-19 restrictions, Erin's deep marketing knowledge paired with her creativity and initiative became obvious immediately. She is keenly able to pinpoint obstacles to efficient workflow and suggest remedies. The BPL was lucky to have her — as any organization would be.",
    author: "Sue Minichiello",
    role: "Strategic Communications & PR Consultant",
    date: "August 2020",
    accent: "var(--bpm-teal)",
  },
  {
    quote:
      "As a creative running a small business, I found the idea of using a mailing list intimidating. Erin empowered me to with manageable steps to broaden the connection with my students and shoppers. She encouraged me to use this powerful tool that I had been neglecting and I’m now seeing a great response. Erin’s  enthusiasm for collaboration and her vast knowledge of email marketing truly elevated my messaging while maintaining authenticity.",
    author: "Angela Zampell",
    role: "Owner, Hot Glue Heroes",
    date: "",
    accent: "var(--bpm-coral)",
  },
  {
    quote:
      "Erin did a great job getting our first marketing effort at SEMplicity off the ground. She worked directly with me throughout the entire marketing lifecycle — from vision and messaging all the way to tactics and materials. Throughout, she could be counted upon to come up with creative, original, and valuable ideas. More importantly, she has the skills to actualize those ideas, generate attractive content, and direct coordinated marketing initiatives. She is also a delight to work with, and I wouldn't hesitate to do it again.",
    author: "George Boitano",
    role: "Owner, SEMplicity Inc.",
    date: "March 2017",
    accent: "var(--bpm-mustard)",
  },
];

export const Testimonials = () => {
  return (
    <section id="testimonials" className="section-divider radio-waves relative" style={{ "--rw-x": "100%", "--rw-y": "50%" }} data-testid="testimonials-section">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-8">
          <div className="lg:col-span-8">
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mt-5">
              Testimonials
            </h2>
          </div>
          <div className="lg:col-span-4 lg:flex lg:items-end">
            <p className="text-[14px] text-[color:var(--bpm-muted)] max-w-sm">
              Verified recommendations from{" "}
              <a
                href="https://www.linkedin.com/in/mzamar/details/recommendations/"
                target="_blank"
                rel="noopener noreferrer"
                className="link-underline text-[color:var(--bpm-cream)]"
                data-testid="linkedin-recommendations-link"
              >
                LinkedIn
              </a>
              .
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {quotes.map((q, i) => (
            <figure
              key={i}
              className="callout fade-up p-7 md:p-8 flex flex-col"
              style={{ animationDelay: `${i * 70}ms` }}
              data-testid={`testimonial-${i}`}
            >
              <div className="font-display text-4xl leading-none mb-2" style={{ color: q.accent }} aria-hidden>
                &ldquo;
              </div>
              <blockquote className="text-[14.5px] md:text-[15px] leading-[1.7] text-[color:var(--bpm-cream)] flex-1">
                {q.quote}
              </blockquote>
              <figcaption className="mt-3 pt-3" style={{ borderTop: "1px solid var(--bpm-line)" }}>
                <div className="font-display text-[15px]">{q.author}</div>
                <div className="text-[12px] text-[color:var(--bpm-muted)] mt-1.5 leading-[1.5]">{q.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
